import React, { useState } from 'react';
import '../../styles/PrivacySettingsContent.css';
import { FaArrowLeft } from 'react-icons/fa';
import { FaBalanceScale, FaChartLine, FaHeartBroken, FaLeaf, FaExclamationTriangle } from 'react-icons/fa';

const topicIcons = {
  'social-injustice': <FaBalanceScale size={32} />,
  'economic-hell': <FaChartLine size={32} />,
  'emergency': <FaExclamationTriangle size={32} />,
  'ecosystem+': <FaLeaf size={32} />,
  'romantic-chaos': <FaHeartBroken size={32} />,
};

function PrivacySettingsContent({ onBack }) {
  const [privacySetting, setPrivacySetting] = useState('anonymous'); // Default to anonymous

  const handlePrivacyChange = (setting) => {
    setPrivacySetting(setting);
  };

  const handleSelectSection = (sectionId) => {
    console.log(`Selected section for ${privacySetting} post: ${sectionId}`);
    // Implement logic to handle posting with the selected privacy setting and section
  };

  return (
    <div className="privacy-settings-container">
      <div className="privacy-header">
        <button onClick={onBack} className="back-button"><FaArrowLeft /></button>
        <h2>PRIVACY SETTINGS</h2>
      </div>

      <div className="privacy-toggle">
        <button
          className={`toggle-button ${privacySetting === 'anonymous' ? 'active' : ''}`}
          onClick={() => handlePrivacyChange('anonymous')}
        >
          Anonymous
        </button>
        <button
          className={`toggle-button ${privacySetting === 'semi-anonymous' ? 'active' : ''}`}
          onClick={() => handlePrivacyChange('semi-anonymous')}
        >
          Semi-anonymous
        </button>
      </div>

      <div className="privacy-details">
        <h3>{privacySetting === 'anonymous' ? 'ANONYMOUS PRIVACY' : 'SEMI-ANONYMOUS PRIVACY'}</h3>
        <ul className="privacy-list">
          {privacySetting === 'anonymous' ? (
            <>
              <li>Vent freely with no profile connection.</li>
              <li>Your vents are posted without your username or identifiable information.</li>
              <li>Your identity is completely masked from other users.</li>
              <li>Interactions (if any) with your anonymous vents are detached from your profile.</li>
              <li>Prioritizes maximum privacy.</li>
              <li>Ensures your thoughts are shared without any link back to you.</li>
              <li className="note">Note: the company, however, still allows the company to know who posted what for moderation.</li>
              <li>Select a relevant category below to post your anonymous vent.</li>
            </>
          ) : (
            <>
              <li>Vent while maintaining a degree of identity.</li>
              <li>Your vents are associated with your chosen username.</li>
              <li>Other users can see who posted your vents.</li>
              <li>Allows for a sense of community and interaction tied to a chosen identity.</li>
              <li>Provides a level of separation from your real-world identity.</li>
              <li>Select a relevant section below to post your semi-anonymous vent.</li>
            </>
          )}
        </ul>
      </div>

      <div className="select-section">
        <h3>Select applicable section ({privacySetting} privacy setting)</h3>
        <div className="topic-buttons">
          {[
            { id: 'social-injustice', label: 'Social Injustice' },
            { id: 'economic-hell', label: 'Economic Hell' },
            { id: 'emergency', label: 'Emergency' },
            { id: 'ecosystem+', label: 'Ecosystem +' },
            { id: 'romantic-chaos', label: 'Romantic Chaos' },
          ].map((topic) => (
            <button key={topic.id} className="topic-button" onClick={() => handleSelectSection(topic.id)}>
              <div className="topic-icon">{topicIcons[topic.id]}</div>
              <div className="topic-label">{topic.label}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PrivacySettingsContent;
